(function () {
  'use strict';

  if (!('PerformanceObserver' in window)) return;

  let largestShift = 0;
  let largestSource = '';
  let shiftCount = 0;

  function describeNode(node) {
    if (!(node instanceof Element)) return '';

    let description = node.tagName.toLowerCase();

    if (node.id) {
      description += `#${node.id}`;
    }

    if (node.classList.length) {
      description += `.${Array.from(node.classList).slice(0, 3).join('.')}`;
    }

    return description;
  }

  const observer = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      if (entry.hadRecentInput || entry.value <= 0) return;

      shiftCount += 1;

      const source =
        entry.sources
          ?.map((item) => describeNode(item.node))
          .filter(Boolean)
          .join(' | ') || 'Unknown';

      console.group(`CLS shift: ${entry.value.toFixed(4)}`);
      console.log('Source:', source);
      console.log('Entry:', entry);
      console.groupEnd();

      if (entry.value > largestShift) {
        largestShift = entry.value;
        largestSource = source;
      }
    });
  });

  observer.observe({
    type: 'layout-shift',
    buffered: true
  });

  window.addEventListener('pagehide', () => {
    console.log('CLS debug summary', {
      shiftCount,
      largestShift,
      largestSource
    });
  });
})();